import React from "react";
import { inject, observer } from "mobx-react";
import { Message, useMessage, useMessageGetter } from "react-message-context";
import { Button, ButtonRow } from "@op/opds.opux";
import { Modal } from "@op/opds.opux-modal";
import { reaction } from "mobx";

const DataDeletedModal = observer(({ SessionStore, FeedbackStore }) => {
  const { showDataDeletedModal, dataDeletedWithAcknowledgement } = SessionStore;
  const msgs = useMessageGetter("session.dataDeleted.modal");
  const redirectUrl = useMessage("url.form.unidentified")();

  reaction(
    () => SessionStore.showDataDeletedModal,
    () => FeedbackStore.reset()
  );

  const createFooter = () => (
    <ButtonRow className="cff-modal__footer">
      <Button id="CFF-dataDeleted-close" compact href={redirectUrl}>
        {msgs("close")}
      </Button>
    </ButtonRow>
  );

  return (
    <Modal
      id="CFF-dataDeleted"
      footer={createFooter()}
      isOpen={showDataDeletedModal}
      title={msgs("title")}
      appElement={document.getElementById("customerfeedbackopfi-main")}
      onUpdate={(state) => {
        SessionStore.showDataDeletedModal = state.open;
      }}
    >
      <div className="opux-v6__opds">
        <p>
          <Message
            id={`session.dataDeleted.modal.text.${
              dataDeletedWithAcknowledgement ? "b" : "a"
            }`}
          />
        </p>
      </div>
    </Modal>
  );
});

export default inject("SessionStore", "FeedbackStore")(DataDeletedModal);
